import Vue from "vue";

export function set_document(state, snapshot) {
  const data = snapshot.data();
  Object.keys(data).forEach(key => {
    Vue.set(state, key, data[key]);
  });
  state.id = snapshot.id;
}

export function set_fetch_timestamp(state) {
  state.lastFetched = +new Date();
}

export function set_document_listener(state, subject) {
  state.document_listener = subject;
}
